import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { useEffect, useState } from "react";
import { Map } from "ol";
import { Options } from "ol/layer/BaseVector";

export function useVectorLayer(
	map: Map | null,
	options: Partial<Options<VectorSource>>,
) {
	const [source] = useState(new VectorSource());

	const [layer] = useState(
		new VectorLayer({
			source,
			...options,
		}),
	);

	useEffect(() => {
		if (!map) return () => {};

		map.addLayer(layer);

		return () => {
			map.removeLayer(layer);
		};
	}, [map, layer]);

	return {
		source,
		layer,
	};
}